module.exports = __webpack_public_path__ + "img/medal-star.57a1e423.svg";